import {useContext, useEffect, useState} from 'react'
import {GridActionsCellItem} from '@mui/x-data-grid'
import DataGridComponent from '../../components/DataGrid'
import {KTSVG} from '../../../_metronic/helpers'
import ToolbarCustom from '../../../_metronic/layout/components/toolbar/toolbars/ToolbarCustom'

import { ProductsContext } from '../../context'
import RegionDetailModal from './RegionDetailModal'
import ImportCollectionModal from '../../components/ImportCollectionModal'
import config from '../../../config.json'

const RegionsPage = () => {
  
  const { regions, regionsLoaded, fetchRegions, createRegion, updateRegion, deleteRegion, countriesLoaded, fetchCountries } = useContext(ProductsContext)

  const [currentRegion, setCurrentRegion] = useState(null)
  const [importCollectionModalOpen, setImportCollectionModalOpen] = useState(false)

  useEffect(() => {
    if(!regionsLoaded) {
      fetchRegions()
    }
  }, [regionsLoaded, fetchRegions])

  useEffect(() => {
    if(!countriesLoaded) {
      fetchCountries()
    }
  }, [fetchCountries, countriesLoaded])

  const onCreateClick = () => {
    setCurrentRegion({
      id: '',
      name: {},
      country: ''
    })
  }

  const onEditClick = (area) => {
    setCurrentRegion(area)
  }

  const onDetailSubmit = async () => {
    let response
    const data = {...currentRegion}
    if(!data.id) {
      response = await createRegion(data)
    } else {
      response = await updateRegion(data.id, data)
    }
    setCurrentRegion(null)
  }

  const onDetailDelete = async () => {
    if(!confirm(`Are you sure you want to delete this region? (${currentRegion?.name?.fr || currentRegion.id})`)) return
    let response = await deleteRegion(currentRegion.id)
    setCurrentRegion(null)
  }

  const promptImportCollection = () => {
    setImportCollectionModalOpen(true)
  }

  return (
    <>
      <ToolbarCustom
        pageTitle={'Regions'}
        primaryButton={regionsLoaded && { onClick: onCreateClick, title: 'Add' }}
        loading={!regionsLoaded}
        filterElements={[(
          config.environment !== 'staging' && <button className='btn btn-sm fw-bold btn-primary' onClick={promptImportCollection}>
            <KTSVG path='/media/icons/duotune/arrows/arr037.svg' className='svg-icon-3' />
            Import from staging
          </button>
        )]}
      />
      <div className='mt-1'>
        <DataGridComponent
          id='regions'
          rows={regions}
          loading={!regionsLoaded}
          columns={[
            {
              field: 'name',
              headerName: 'Region',
              flex: 1,
              minWidth: 180,
              valueGetter: value => value?.en || value?.fr || value?.es || value?.it || 'Missing region name',
            },
            {
              field: 'country',
              headerName: 'Country code',
              width: 150,
              valueGetter: value => value?.toUpperCase() || '',
            },
            {
              field: 'description',
              headerName: 'Description',
              flex: 2,
              minWidth: 200,
              valueGetter: value => value?.en || value?.fr || value?.es || value?.it || '',
            },
            {
              field: 'actions',
              type: 'actions',
              headerName: 'Actions',
              width: 100,
              getActions: ({row}) => [
                <GridActionsCellItem
                  key={`edit-${row.id}`}
                  icon={<i className='bi bi-pencil-square text-primary' />}
                  label='Edit region'
                  onClick={() => onEditClick(row)}
                  color='inherit'
                />,
              ],
            },
          ]}
          pageSizeOptions={[20, 50, 100]}
        />
      </div>
      <RegionDetailModal
        show={Boolean(currentRegion)}
        handleClose={() => setCurrentRegion(null)}
        area={currentRegion}
        setRegion={setCurrentRegion}
        onSubmit={onDetailSubmit}
        onDelete={onDetailDelete} />

      <ImportCollectionModal
        isOpen={importCollectionModalOpen}
        onClose={() => setImportCollectionModalOpen(false)}
        collectionName={"regions"}
        sourceEnvironment={"staging"}
        onImportComplete={async () => {
          // reload collection
          await fetchRegions()
        }} />
    </>
  )
}

const RegionsWrapper = () => {
  return (
    <>
      <RegionsPage />
    </>
  )
}

export default RegionsWrapper
